<template>
  <div>
    <!-- <p class="c-inner-title">人群包筛选</p> -->
    <div class="auto">
      <page-title title="人群包筛选" icon="fa-wechat"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" @click="handle" class="el-icon-plus" size="small"> 添加人群包</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              <el-input placeholder="搜索名称" v-model.trim="filter.search" clearable class="m-lr-5" style="width:200px;" size="small"></el-input>
              <el-button type="primary" @click="handleChangeFilter" size="small">搜索</el-button>
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="jd_crowd_id" label="京东人群包ID"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="jd_job_id" label="任务ID"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="jd_status_name" label="京东状态"></el-table-column>
            <el-table-column prop="jd_file_name" label="文件名"></el-table-column>
            <el-table-column prop="jd_count" label="人数"></el-table-column>
            <el-table-column prop="jd_error" label="错误"></el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column prop="jd_complete_time" label="完成时间"></el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  @click="handlePreview(scope.row)"
                  type="primary"
                  size="small">
                  查看
                </el-button>
                <el-button
                  @click="handleDelete(scope.row)"
                  size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="人群包" :modal-append-to-body="false" fullscreen :visible.sync="dialogVisible" @close="handleExit">
      <!-- <el-steps :active="active" align-center>
        <el-step title="基本信息"></el-step>
        <el-step title="标签抽取"></el-step>
        <el-step title="计算"></el-step>
        <el-step title="完成"></el-step>
      </el-steps> -->
      <el-steps :active="active" simple>
        <el-step title="基本信息" icon="el-icon-edit"></el-step>
        <el-step title="标签抽取" icon="el-icon-collection-tag"></el-step>
        <el-step title="计算" icon="el-icon-cpu"></el-step>
        <el-step title="完成" icon="el-icon-circle-check"></el-step>
      </el-steps>
      <div class="dialog-box auto" v-loading="dialogLoading">
        <div class="dialog-step auto dialog-step1" v-show="active == 1">
          <el-form ref="form" :rules="rules" :model="form" label-width="60px" size="small">
            <el-form-item prop="name" label="名称">
              <el-input v-model.trim="form.name" style="width:420px;"></el-input>
            </el-form-item>
            <el-form-item prop="remark" label="备注">
              <el-input type="textarea" v-model.trim="form.remark" rows="4" style="width:420px;float:left;"></el-input>
              <el-tooltip class="item" effect="light" placement="right">
                <div slot="content">
                  请按以下格式输入-示例：<br>
                  人群包内容：汽车购买人群投放数据<br>
                  人群包用途：基于此人群包做用户行为分析
                </div>
                <i class="el-icon-warning fr font18 blue" style=""></i>
              </el-tooltip>
            </el-form-item>
          </el-form>
          <div class="form-footer form-footer1 auto">
            <el-button @click="handleExit">取  消</el-button>
            <el-button type="primary" @click="stepFirstSubmit" :loading="btnLoading">下一步</el-button>
          </div>
        </div>
        <div class="dialog-step auto dialog-step2" v-show="active == 2">
          <div class="step2-box auto">
            <div class="fl step2-box-left">
              <jd-filters :filters="filters" v-model="chooseTagGroup" @getChooseVal="getChooseVal"></jd-filters>
            </div>
            <div class="fr step2-box-right">
              <jd-filters-tag-group v-model="chooseTagGroup" @getChooseVal="getChooseValTagGroup"></jd-filters-tag-group>
            </div>
          </div>
          <div class="form-footer auto" style="margin-top: 40px">
            <el-button @click="handleExit">取  消</el-button>
            <el-button type="primary" @click="backStep(1)">上一步</el-button>
            <el-button type="primary" @click="stepSecondSubmit" :loading="btnLoading">下一步</el-button>
          </div>
        </div>
        <div class="dialog-step auto dialog-step2" v-show="active == 3">
          <div class="step2-box auto">
            <div class="fl step2-box-right step3-box-left">
              <jd-filters-tag-group v-model="chooseTagGroup" :draggable="true"></jd-filters-tag-group>
            </div>
            <div class="fr step2-box-left step3-box-right">
              <jd-filters-show v-model="chooseVal"></jd-filters-show>
            </div>
          </div>
          <div class="form-footer auto" style="margin-top: 40px">
            <el-button @click="handleExit">取  消</el-button>
            <el-button type="primary" @click="backStep(2)">上一步</el-button>
            <el-button type="primary" @click="stepThirdSubmit" :loading="btnLoading">提交</el-button>
          </div>
        </div>
        <div class="dialog-step auto dialog-step2" v-show="active == 4">
          <div class="step4-box auto">
            <i class="el-icon-success"></i><br>
            已创建成功！
          </div>
          <div class="form-footer auto" style="margin-top: 40px">
            <el-button type="primary" @click="stepFourthSubmit" :loading="btnLoading">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="人群包详情" :modal-append-to-body="false" fullscreen :visible.sync="dialogPreviewVisible" @close="handleExitPreview">
      <div class="dialog-box auto">
        <div class="dialog-step auto" style="margin-top:0;">
          <el-form ref="previewData" :model="previewData" label-width="80px" size="small">
            <el-form-item prop="name" label="名称">
              <el-input v-model.trim="previewData.name" disabled></el-input>
            </el-form-item>
            <el-form-item prop="remark" label="备注">
              <el-input type="textarea" v-model.trim="previewData.remark" disabled></el-input>
            </el-form-item>
            <el-form-item prop="filter" label="筛选条件">
              <jd-filters-show v-model="previewData.filter" :disabled="true"></jd-filters-show>
            </el-form-item>
          </el-form>
          <div class="form-footer auto">
            <el-button @click="handleExitPreview">关  闭</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Setting, Package } from '@/model'
export default {
  data () {
    return {
      dialogVisible: false,
      tableData: [],
      search: '',
      form: {
        name: '',
        filter: [],
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: '名称不能为空！', trigger: 'blur' }
        ],
        filter: [
          { required: true, message: '请选择标签！', trigger: 'blur' }
        ]
      },
      loading: false,
      btnLoading: false,
      filter: {
        search: '',
        page: '1',
        limit: '20'
      },
      total: 0,
      active: 1,
      filters: {},
      chooseTagGroup: {},
      chooseVal: [
        {
          jbc: 'must',
          segments: [
            {
              group: '',
              jbc: 'must',
              segments: [
              ]
            }
          ]
        }
      ],
      dialogLoading: false,
      dialogPreviewVisible: false,
      previewData: {
        name: '',
        remark: '',
        filter: ''
      }
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    }
  },
  methods: {
    handleChangeFilter () {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        type: '',
        search: '',
        page: '1',
        limit: '20'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/package/package_filter', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.handleList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    handlePreview (row) {
      this.dialogPreviewVisible = true
      this.previewData = {
        name: row.name,
        remark: row.remark,
        filter: JSON.parse(JSON.parse(row.jd_filter_name))
      }
    },
    handleExitPreview () {
      this.dialogPreviewVisible = false
      this.previewData = {
        name: '',
        remark: '',
        filter: ''
      }
    },
    handleDelete (row) {
      this.$confirm('确定要删除此人群包吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true
        let res = await Package.delPackageInfo({id: row.id})
        this.loading = false
        if (res !== false && !res['err_code']) {
          this.handleList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        } else {
          this.$message.error(res['err_msg'])
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    handle (index, data) {
      var row = Object.assign({}, this.formClone)
      if (index > -1) {
        row = Object.assign({}, data[index])
      }
      this.form = row
      this.dialogVisible = true
    },
    stepFirstSubmit () {
      this.$refs['form'].validateField('name', valid => {
        if (!valid) {
          this.active = 2
        }
      })
    },
    stepSecondSubmit () {
      let status = false
      for (let key in this.chooseTagGroup) {
        if (this.chooseTagGroup[key]['value'] && this.chooseTagGroup[key]['value'].length) {
          status = true
        }
      }
      if (status) {
        this.active = 3
        this.chooseVal = [
          {
            jbc: 'must',
            segments: [
              {
                group: '',
                jbc: 'must',
                segments: [
                ]
              }
            ]
          }
        ]
      } else {
        this.$message.error('需至少选择一组条件！')
      }
    },
    stepThirdSubmit () {
      let status = false
      this.chooseVal.map(item => {
        item['segments'].map(item2 => {
          item2['segments'].map(item3 => {
            status = true
          })
        })
      })
      if (status) {
        this.submitFn()
      } else {
        this.$message.error('需至少选择一组条件！')
      }
    },
    async submitFn () {
      let filter = []
      this.chooseVal.map(item => {
        let set = {}
        set['jbc'] = item['jbc']
        set['segments'] = []
        item['segments'].map(item2 => {
          let group = {}
          group['group'] = item2['group']
          group['jbc'] = item2['jbc']
          group['segments'] = []
          item2['segments'].map(item3 => {
            let details = {}
            details['tagCode'] = item3['value']['tagCode']
            details['tagTypeView'] = item3['value']['tagTypeView']
            details['values'] = Array.isArray(item3['value']['values']) ? item3['value']['values'] : [item3['value']['values']]
            if (item3['parent']) {
              details['parent'] = item3['parent']
            }
            group['segments'].push(details)
          })
          set['segments'].push(group)
        })
        filter.push(set)
      })
      // console.log('filter', filter)
      // return false
      this.dialogLoading = true
      let res = await Package.savePackageInfo({
        name: this.form.name,
        jd_filter_name: JSON.stringify(this.chooseVal),
        remark: this.form.remark,
        jd_filter: JSON.stringify(filter)
      })
      this.dialogLoading = false
      if (res !== false && !res['err_code']) {
        this.handleList()
        this.active = 4
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    stepFourthSubmit () {
      this.active = 1
      this.dialogVisible = false
      this.form = {
        name: '',
        filter: [],
        remark: ''
      }
      this.chooseVal = [
        {
          jbc: 'must',
          segments: [
            {
              group: '',
              jbc: 'must',
              segments: [
              ]
            }
          ]
        }
      ]
      this.chooseTagGroup = {}
    },
    getChooseVal (val) {
      // console.log(val)
      this.chooseTagGroup = JSON.parse(JSON.stringify(val))
    },
    getChooseValTagGroup (val) {
      this.chooseTagGroup = JSON.parse(JSON.stringify(val))
    },
    backStep (step) {
      this.active = step
    },
    handleExit () {
      this.stepFourthSubmit()
    },
    async handleList () {
      this.loading = true
      var res = await Package.getPackageList(this.filter)
      this.loading = false
      if (res !== false && !res['err_code']) {
        this.tableData = res['data']['list']
        this.total = res['data']['total']
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    async getJdFilterCriteria () {
      let res = await Package.getJdFilterCriteria()
      if (!res['err_code']) {
        this.filters = res['data']
      }
    }
  },
  created () {
    this.queryToFilter()
    this.getJdFilterCriteria()
  }
}
</script>

<style scoped>
.form-footer {
  text-align: center;
}
.form-footer1 {
  margin-top: 100px;
}
.dialog-step {
  margin: 50px auto 0;
}
.dialog-step1 {
  width: 500px;
  margin-top: 100px;
}
.step2-box {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.step2-box-left {
  width: calc(100% - 240px);
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.jd-filter-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.jd-filter-box>div {
  width: 100%;
}
.step2-box-right {
  width: 240px;
  min-height: calc(100%);
}
.step3-box-right {
  height: calc(100vh - 320px);
}
.step4-box {
  text-align: center;
  padding: 100px 0 50px;
  line-height: 40px;
}
.step4-box i {
  font-size: 60px;
  color: green;
}
</style>
